import { useLocation, useNavigate } from 'react-router-dom';
import { LogIcon, FeedIcon, LeaderboardIcon, HistoryIcon } from '../Icons';
import './BottomNav.css';

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  // Settings is deliberately absent: it is reached by the profile icon in the
  // header, which keeps the bar for the four places you actually move between.
  const tabs = [
    { path: '/', label: 'Log', Icon: LogIcon },
    { path: '/feed', label: 'Feed', Icon: FeedIcon },
    { path: '/leaderboard', label: 'Leaderboard', Icon: LeaderboardIcon },
    { path: '/history', label: 'History', Icon: HistoryIcon },
  ];

  return (
    <nav className="bottom-nav" role="navigation" aria-label="Bottom Navigation">
      {tabs.map(({ path, label, Icon }) => {
        const isActive = location.pathname === path;
        return (
          <button
            key={path}
            className={`bottom-nav__item ${isActive ? 'bottom-nav__item--active' : ''}`}
            onClick={() => navigate(path)}
            aria-label={label}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon size={24} className="bottom-nav__icon" />
            <span className="bottom-nav__label">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
